(function () {
  const body = document.body;
  const drawer = document.querySelector('[data-iwa-drawer]');
  const openMenu = document.querySelector('[data-iwa-menu-open]');
  const closeMenu = document.querySelector('[data-iwa-menu-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    openMenu?.setAttribute('aria-expanded', String(open));
    body.classList.toggle('iwa-drawer-open', open);
  }

  openMenu?.addEventListener('click', () => setDrawer(true));
  closeMenu?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));

  const popup = document.querySelector('[data-iwa-popup]');
  if (popup) {
    const delay = Number(popup.dataset.delay || 1800);
    const frequency = popup.dataset.frequency || 'session';
    const storage = frequency === 'always' ? null : frequency === 'days' ? localStorage : sessionStorage;
    const key = 'iwadira-newsletter-popup';
    let seen = false;

    try {
      const value = storage?.getItem(key);
      if (frequency === 'days' && value) seen = Date.now() - Number(value) < 7 * 86400000;
      else seen = Boolean(value);
    } catch (error) {
      seen = false;
    }

    const closePopup = () => {
      popup.classList.remove('is-open');
      window.setTimeout(() => { popup.hidden = true; }, 260);
      try { storage?.setItem(key, String(Date.now())); } catch (error) { /* Storage can be disabled. */ }
    };

    if (!seen && !Shopify.designMode) {
      window.setTimeout(() => {
        popup.hidden = false;
        requestAnimationFrame(() => popup.classList.add('is-open'));
      }, delay);
    }

    popup.querySelector('[data-iwa-popup-close]')?.addEventListener('click', closePopup);
    popup.addEventListener('click', (event) => { if (event.target === popup) closePopup(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { closePopup(); setDrawer(false); }
    });
  }
})();
